module.exports = __webpack_public_path__ + "static/media/3 กรณีสละสิทธิ์ก่อนทำสัญญา_0.11f6736f.jpg";